export default "__VITE_ASSET__C$rSDUV$__"